import { Moment } from "moment";
import "moment/locale/pt-br";

export const DATE_LOCALE = "pt-br";

export const formatMomentPtBr = (date: Moment, format: string): string =>
  date.clone().locale(DATE_LOCALE).format(format);

const formatDate = (date: Date): string =>
  `${date.getFullYear()}-${`${date.getMonth() + 1}`.padStart(2, "0")}-${`${date.getDate()}`.padStart(2, "0")}`;

const getMonthBounds = (date: Date): { startDate: Date; endDate: Date } => {
  const startDate = new Date(date.getFullYear(), date.getMonth(), 1);
  const endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

  return { startDate, endDate };
};

export const getCurrentMonthDateRange = (): { startDate: string; endDate: string } => {
  const today = new Date();
  const { startDate, endDate } = getMonthBounds(today);
  return { startDate: formatDate(startDate), endDate: formatDate(endDate) };
};

export const getMonthDateRange = (date: Date): { startDate: string; endDate: string } => {
  const { startDate, endDate } = getMonthBounds(date);
  return { startDate: formatDate(startDate), endDate: formatDate(endDate) };
};

export function isValidDate(date: Date) {
  return date instanceof Date && !isNaN(date.getTime());
}

export function formatDateRange(startDate: Date, endDate: Date): string {
  if (!isValidDate(startDate) || !isValidDate(endDate)) return '- -';

  const startDay = startDate.getDate();
  const endDay = endDate.getDate();
  const startMonth = startDate.getMonth();
  const endMonth = endDate.getMonth();
  const startYear = startDate.getFullYear();
  const endYear = endDate.getFullYear();

  const daysInMonth = new Date(endYear, endMonth + 1, 0).getDate();
  const sameMonth = startMonth === endMonth && startYear === endYear;
  const isStartOfMonth = startDay === 1;
  const isEndOfMonth = endDay === daysInMonth;

  if (sameMonth && isStartOfMonth && isEndOfMonth) {
    const formatter = new Intl.DateTimeFormat("pt-BR", {
      month: "long",
      year: "numeric",
    });

    const formatted = formatter.format(startDate);
    const monthName = formatted.split(" ")[0];
    const capitalizedMonth = monthName.charAt(0) + monthName.slice(1);

    return `${capitalizedMonth.toUpperCase()} ${startYear}`;
  }

  const formatDay = (d: Date) => d.toLocaleDateString("pt-BR", { timeZone: "UTC" });

  return `Período: de ${formatDay(startDate)} até ${formatDay(endDate)}`;
}
